import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialOfferListComponent } from './special-offer-list/special-offer-list.component';
import { SpecialOfferRoutingModule } from './special-offers-routing.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { SpecialOfferCardViewComponent } from './special-offer-list/special-offer-client-card-view/special-offer-card-view.component';
import { SpecialOfferClientFilterModalComponent } from './special-offer-list/special-offer-filter-modal/special-offer-filter-modal.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { PreviewInformationComponent } from './special-offer-list/preview/preview-information/preview-information.component';
import { IconsModule } from '@progress/kendo-angular-icons';
import { PreviewComponent } from './special-offer-list/preview/preview.component';
import { PreviewSelectorComponent } from './special-offer-list/preview/preview-selector/preview-selector.component';
import { PreviewDocumentsComponent } from './special-offer-list/preview/preview-documents/preview-documents.component';
import { SpecialOfferRequestedComponent } from './special-offer-list/preview/special-offer-requested/special-offer-requested.component';

@NgModule({
  declarations: [
    SpecialOfferListComponent,
    SpecialOfferCardViewComponent,
    SpecialOfferClientFilterModalComponent,
    PreviewInformationComponent,
    PreviewComponent,
    PreviewSelectorComponent,
    PreviewDocumentsComponent,
    SpecialOfferRequestedComponent,
  ],
  imports: [
    SpecialOfferRoutingModule,
    CommonModule,
    InputsModule,
    PipeModule,
    ComponentsModule,
    TranslateModule.forChild(),
    DateInputsModule,
    FormsModule,
    IconsModule,
  ],
})
export class SpecialOffersModule {}
